import { CampaignModel } from './CampaignModel';
import { RequestModel } from './RequestModel';

export class TreesViewModel{
    campaign: CampaignModel;
    request: RequestModel;
}
